﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global, relodeCurrentPage } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import { SaopChangePwdView } from '../Account/saop-change-pwd-view'

export class SaopSettingsView { 
    //
    private _saopServicesCore :SaopServicesCore;
    private _saopChangePwdView : SaopChangePwdView;

    constructor(viewId:string,libName:string = "") {
        this._saopServicesCore = new SaopServicesCore(); 
        this._saopChangePwdView = new SaopChangePwdView(viewId,libName);
    }

    initView(): void {
        global.ConsoleLogDegug("SaopSettingsView.initView");

        this.bindViewEvents();   
        
        this.checkPasswordStrength();
        
    }

    bindViewEvents(){
        global.ConsoleLogDegug("SaopSettingsView.bindGridEvents");
        let _this = this;
        //
        $("#selectJezik").off("change");
        $("#selectJezik").on('change', function (row) {
            _this.vrstaJezikaChanged();
        });  
        
        this._saopChangePwdView.bindViewEvents();      
    }

    vrstaJezikaChanged(): void {
        global.ConsoleLogDegug("SaopSettingsView.vrstaJezikaChanged");
        let _this = this;

        let vrstaJezikaElement = document.getElementById('selectJezik') as HTMLSelectElement;
        let jezik = vrstaJezikaElement.options[vrstaJezikaElement.selectedIndex].value;

        let idWebOperaterja = (document.getElementById('IDWebOperaterja') as HTMLInputElement).value;

        let data = { idweboperaterja: idWebOperaterja, jezik: jezik};

        this._saopServicesCore.afterDone = function (response) {
            if (response.alertMessage) {
                alertify.message(response.alertMessage);
            }

            if (response.viewContent) {
                $("#messageBanner").html(response.viewContent);
            }

            if (response.success) {
                //reload current page 
                relodeCurrentPage();
            }
            else {
                $("#selectJezik").val(response.jezik);
            }
        };
        this._saopServicesCore.ExecuteAction({
            action: "Settings/UpdateSaopwebOperaterjiJezik"
            , data: data
            , type: "POST"
            , spinnerDivId: "#absenceConfirmationPendingLoading"
        });        
    }

    public checkPasswordStrength():void{
        this._saopChangePwdView.checkPasswordStrength();
    }

}


